const en = {
  // Generic
  Name: 'Name',
  Cancel: 'Cancel',
  'Add pipeline': 'Add pipeline',
  Pipeline: 'Pipeline',
  Pipelines: 'Pipelines',
  Error: 'Error',
  Loading: 'Loading',
  Algorithms: 'Algorithms',
  Results: 'Results',
  Homepage: 'Homepage',
  No: 'No',
  Yes: 'Yes',
  // CreatePipelineDialog.tsx
  'Please check your input!': 'Please check your input!',
  'Error creating pipeline:': 'Error creating pipeline:',
  Create: 'Create',
  Import: 'Import',
  Copy: 'Copy',
  'Create pipeline': 'Create pipeline',
  // formProcessingService.ts
  'Not Authenticated': 'Not Authenticated',
  'No file given': 'No file given',
  'Pipeline not available': 'Pipeline not available',
  'Should not happen': 'Should not happen',
  // ImportPipeline.tsx
  'Upload File': 'Upload File',
  Filename: 'Filename',
  // AppBreadcrumb.tsx
  Home: 'Home',
  // Footer.tsx
  'Laboratory for Machine Tools and Production Engineering (WZL) of RWTH Aachen University':
    'Laboratory for Machine Tools and Production Engineering (WZL) of RWTH Aachen University',
  // LinkList.tsx
  Links: 'Links',
  // links.tx
  Source: 'Source',
  // UserMenu.tsx
  Logout: 'Logout',
  // Login.tsx
  Login: 'Login',
  'Accounts are managed through Keycloak as OpenID Provider. Follow the link below to sign in.':
    'Accounts are managed through Keycloak as OpenID Provider. Follow the link below to sign in.',
  'Virtual Machine Vision Lab': 'Virtual Machine Vision Lab',
  // TODO: translate
  'Virtuelles Bildverarbeitungslabor zur Vorlesung "Optische Messtechnik und Bildverarbeitung".':
    'Virtuelles Bildverarbeitungslabor zur Vorlesung "Optische Messtechnik und Bildverarbeitung".',
  'Bei Fragen, konstruktiver Kritik oder allgemeinen Anmerkungen senden Sie bitte eine E-Mail an Matthias Bodenbenner.':
    'For any questions and suggestions, please send an e-mail to Matthias Bodenbenner.',
  'E-Mail': 'E-Mail',
  // DoubleParameter.tsx
  'real out of': 'real out of',
  // IntParameter.tsx
  'integer out of': 'integer out of',
  // parameterValidatorService.ts
  'Invalid Input': 'Invalid Input',
  'Not a number': 'Not a number',
  'Not an integer': 'Not an integer',
  // AddEdgeDialog.tsx
  'Create Edge': 'Create Edge',
  // AddServiceDialog.tsx
  Parameter: 'Parameter',
  'Expected Inputs': 'Expected Inputs',
  'Create Service': 'Create Service',
  // BottomNavigationBar.tsx
  'Center Edge': 'Center Edge',
  'Edit Edge': 'Edit Edge',
  'Remove Edge': 'Remove Edge',
  'Add Edge': 'Add Edge',
  'Center Service': 'Center Service',
  'Edit Service': 'Edit Service',
  'Remove Service': 'Remove Service',
  'Add Service': 'Add Service',
  'Error fetching services.': 'Error fetching services.',
  // ControlNavigationBar.tsx
  Run: 'Run',
  Save: 'Save',
  // ServiceDrawer.tsx
  Services: 'Services',
  // ConfirmDialog.tsx
  Confirm: 'Confirm',
  // PipelineTable.tsx
  Delete: 'Delete',
  // StartPage.tsx
  'Optische Messtechnik und Bildverarbeitung': 'Optical metrology and image processing',
  Visionlab: 'Visionlab',
  'das virtuelle Bildverarbeitungslabor': 'the Virtual Machine Vision Lab',
  DemoBanner: 'This application is a beta version for demonstration purpose. It is under active development! ',
  IntroductionOne:
    'The application of theoretical knowledge is essential for gaining a deeper understanding of learned subjects. However, manual execution of image processing algorithms is not possible without considerable effort. Furthermore, the behaviour of image processing algorithms cannot be conveyed clearly this way. In recent years we assigned programming exercises for the application of the algorithms, but made the experience that students in general did not like them, often times due to a lack of prior programming experience.',
  IntroductionThree:
    'For technical questions or questions regarding the content, please contact',
  'Herzlich Willkommen in <i>Visionlab</i>, dem virtuellen Bildverarbeitungslabor im Rahmen der Masterveranstaltung <i>Optische Messtechnik und Bildverarbeitung</i>.':
  'Welcome in <i>Visionlab</i>, the Virtual Machine Vision Lab of the Master course <i>Optical Metrology and Image Processing</i>.',
  IntroductionTwo:
  'Therefore, we are testing a new, self-developed, form of digital education. The <i>Visionlab</i> offers you an opportunity to analyze the behaviour of image processing algorithms and apply theoretical knowledge from the lecture to simple examples. To use the <i>Visionlab</i>, there is no previous knowledge in programming required. In the lecture and group exercises you will learn everything you need to know to successfully work on the exercises. Furthermore, you can find documentation for every algorithm with explanations and links to literature for further reading.',
  // PipelineList.tsx
  'No pipelines found': 'No pipelines found',
  // AlgorithmTable.tsx
  'Module':'Module',
  'Parameters':'Parameters',
  'ReturnValues':'Return Values',
  // AlgorithmTable.tsx/Algorithm Translations; Algorithm names
  'Addieren':'Add',
  'Dividieren':'Divide',
  'Multiplizieren':'Multiply',
  'Subtrahieren':'Subtract',
  'Einzelbild':'Single Frame',
  'Spezialbild':'Special Frame',
  'Video':'Video',
  'Gradient':'Gradient',
  'Schärfen':'Sharpen',
  'Glättung':'Smoothing',
  'Canny-Edge-Detektor':'Canny-Edge-Detector',
  'Connected Components':'Connected Components',
  'Binarisieren':'Binarize',
  'In RGB-Bild umwandeln':'Convert to RGB-Image',
  'Dilatation':'Dilatation',
  'Erosion':'Erosion',
  'Gammakorrektur':'Gamma correction',
  'Bild in Graustufen konvertieren':'Convert image to grayscale',
  'Skalieren':'Scale',
  // Algorithm Translations; Algorithm Modules
  'Grundoperationen':'Basic operations',
  'Bildquellen':'Image source',
  'Filteroperationen':'Filter operations',
  'Andere':'Others',
  'Pre-Processing':'Pre-Processing',
  // Algorithm Translations; Algorithm Parameters
  'Datei':'File',
  'Endlosschleife':'Infinite loop',
  'Maske':'Mask',
  'Orientiereung':'Orientation',
  'Kernel Größe':'Kernel size',
  'Filter':'Filter',
  'Filtergröße':'Filter size',
  'Randverhalten':'Edge behaviour',
  'Unterer Grenzwert':'Lower limit',
  'Oberer Grenzwert':'Upper limit',
  'Nachbarschaft':'Neighbourhood',
  'Threshold':'Threshold', // Also Return Value
  'Gammafaktor':'Gamma factor',
  'Größe':'Size',
  'Achse':'Axis',
  // AlgorithmDocumentation.tsx
  'Requested documentation not found!' : 'Requested documentation not found!',
  'An unexpected error occured!' : 'An unexpected error occured!',
};

export default en;
